$(document).ready(function(){
  $('predictive-search.search-modal__form.small-hide img').on('click',function(){
    $('predictive-search.search-modal__form').addClass('activeon');
    $('.header-row').addClass('activeon')
})
$('a.searchClose').on('click',function(){
     $('predictive-search.search-modal__form').removeClass('activeon');
    $('.header-row').removeClass('activeon')
})
  $('summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset').on('click',function(){
    $('details#Details-menu-drawer-container').toggleClass('menu-opening');
    $('body').toggleClass('overflow-hidden-tablet')
})
  // Wait for the DOM to be ready

  // Attach click event handler to the plus button
$('button.quantity__button.no-js-hidden.plus').on('click', function() {
    $('span#subtotal-value').css('display','none');
    var currentPrice = parseFloat($('span.price-item.price-item--regular span.money').text().replace('$', ''));
    var currentQuantity = parseInt($('input.quantity__input').val());
    // var newQuantity = currentQuantity + 1;
    // $('input.quantity__input').val(currentQuantity);
    var newTotalPrice = currentPrice * currentQuantity;
    $('span.updated_price').text('$' + newTotalPrice.toFixed(2));
    $('input.quantity__input').trigger('change');
});

// Attach click event handler to the minus button
$('button.quantity__button.no-js-hidden.minus').on('click', function() {
    $('span#subtotal-value').css('display','none');
    var currentPrice = parseFloat($('span.price-item.price-item--regular span.money').text().replace('$', ''));
    var currentQuantity = parseInt($('input.quantity__input').val());
    // Ensure quantity doesn't go below 1
    // var newQuantity = Math.max(currentQuantity - 1, 1);
    // $('input.quantity__input').val(newQuantity);
    var newTotalPrice = currentPrice * currentQuantity;
    $('span.updated_price').text('$' + newTotalPrice.toFixed(2));
    $('input.quantity__input').trigger('change');
});


})